<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">
          {{ "【" + this.$route.query.name + "】" + $t("editing") + "..." }}
        </h2>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("deviceName") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="nodeName" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("os") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.query.os }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("version") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.query.version }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("wanip") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.query.ip }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("lanip") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.query.lanip }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("nodes.natType") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.natTypeStr }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("addTime") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.query.addtime }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("activeTime") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.query.activetime }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("sharebw") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="bandwidth" class="weui-input" />
              </div>
              <div class="weui-cell__hd">
                <label class="weui-label">mbps</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a
          class="weui-btn weui-btn_primary"
          v-on:click="save"
          href="javascript:"
          >{{ $t("save") }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
export default {
  name: "nodeedit",
  mounted() {
    window.debugLog("nodeedit: ", this.$route.query)
    this.nodeName = this.$route.query.name
    this.bandwidth = this.$route.query.bandwidth
  },
  data() {
    return {
      nodeName: "",
      bandwidth: 10,
    }
  },
  props: {
    msg: String,
  },
  computed: {
    natTypeStr() {
      var natType = "未知"
      this.$store.state.nodes.forEach((v) => {
        if (v.name == this.$route.query.name) {
          if (v.natType == 1) {
            natType = "Cone"
          } else {
            natType = "Symmetric"
          }
          return
        }
      })
      return natType
    },
  },
  methods: {
    save() {
      let _this = this
      window.debugLog("save node edit")
      let error
      if (this.$data.nodeName.length < 8) {
        error = this.$t("nodes.nameTooShort")
      }
      if (!this.$isValidString(this.$data.nodeName)) {
        error = this.$t("invalidCharacter")
      }
      if (error) {
        weui.alert(error, {
          buttons: [
            {
              label: this.$t("ok"),
            },
          ],
        })
        return false
      }
      axios
        .post(
          this.$ServerHost +
            "/api/v1/device/" +
            encodeURIComponent(this.$route.query.name) +
            "/edit",
          {
            newName: this.$data.nodeName,
            bandwidth: +this.$data.bandwidth,
          }
        )
        .then((response) => {
          window.debugLog(response)
          if (response.status == 200) {
            // update cache
            this.$store.state.nodes.forEach((v) => {
              if (v.name == this.$route.query.name) {
                v.name = this.$data.nodeName
                v.bandwidth = +this.$data.bandwidth
              }
            })
            this.$store.state.sdwan.Nodes.forEach((v) => {
              if (v.name == this.$route.query.name) {
                v.name = this.$data.nodeName
              }
            })
            weui.alert(_this.$t("saveOK"), {
              buttons: [
                {
                  label: _this.$t("ok"),
                  onClick: function () {
                    _this.$router.go(-1)
                  },
                },
              ],
            })
          } else {
            window.debugLog("node edit error:" + response)
          }
        })
        .catch(function (error) {
          weui.alert(_this.$t("saveError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
          window.debugLog(error)
        })
    },
  },
}
</script>

<style scoped>
@import "../../assets/css/weui.scss";
</style>
